<template>
  <div
    class="my_picker"
    :style="{
  top:$store.state.color.top + 'px',
  left:$store.state.color.left + 'px',
  }"
  >
    <div class="panel_wrap">
      <!--模式选择-->
      <div
        class="f_color_picker_header"
        v-if="$store.state.color.Pattern"
      >
        <span class="small_text">{{$t('components_my_color_picker_index_2298')}}</span>
        <el-select
          popper-class="my_picker_color_select"
          v-model="Pattern"
          :placeholder="$t('view_dialog_index_116')"
          size="small"
          class="picker_Pattern"
          style="width: 166px;"
        >
          <el-option
            v-for="item in $store.state.options.color_Pattern"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <!--渐变设置-->
      <div
        class="gradient_control"
        v-if="Pattern === 'linear_gradient'"
      >
        <div class="gradient_control_bar_wrap">
          <div
            class="gradient_control_bar"
            :style="{
          background: 'linear-gradient('+linear_gradient.deg + 'deg,' +linear_gradient.start_color + ' ' + linear_gradient.start_pointer + '%,' + linear_gradient.end_color + ' ' + linear_gradient.end_pointer +'%)'
          }"
          ></div>
          <div class="gradient_control_slider">
            <div
              class="gradient_control_bar_pointer start_pointer gradient_start_pointer"
              :style="{
              left:linear_gradient.start_pointer/100 * 125 + 'px'
            }"
              :class="select_pointer === 'start' ? 'sele_pointer' : ''"
            >
              <div
                class="pointer_color"
                :style="{
              background: linear_gradient.start_color
              }"
              ></div>
            </div>

            <div
              class="gradient_control_bar_pointer end_pointer gradient_end_pointer"
              :style="{
              left:linear_gradient.end_pointer/100 * 125 + 'px'
            }"
              :class="select_pointer === 'end' ? 'sele_pointer' : ''"
            >
              <div
                class="pointer_color"
                :style="{
              background: linear_gradient.end_color
              }"
              ></div>
            </div>
          </div>
        </div>

        <div
          class="gradient_control_direction"
          :style="{
        transform: 'rotate(' + (parseFloat(linear_gradient.deg) + 90)  + 'deg)'
        }"
        ></div>

        <div class="gradient_control_angle">
          <input
            maxlength="3"
            type="text"
            class="gradient_control_direction_text input"
            v-model="linear_gradient.deg"
            @change="deg_change"
          />
          <span class="small_text angle_unit">°</span>
        </div>

        <div class="gradient_control_preview color_cube_wrap transparent_bg">
          <div
            class="color_cube"
            :style="{
          background: 'linear-gradient('+linear_gradient.deg + 'deg,' +linear_gradient.start_color + ' ' + linear_gradient.start_pointer + '%,' + linear_gradient.end_color + ' ' + linear_gradient.end_pointer +'%)'
          }"
          ></div>
        </div>
      </div>

      <!--颜色按钮模式-->
      <div
        class="default_panel"
        v-show="type === 'default_panel'"
      >
        <!--色盘按钮-->
        <div class="color_table">
          <div
            class="color_cube"
            v-for="(item,i) in colors"
            :key="i"
            :style="{
            background:item.btn_color
          }"
            :class="item.type === 'transparent' ? 'transparent' : ''"
            @click="progress_color_change(i,item)"
          ></div>

          <div
            class="color_cube colour"
            @click="to_custom_color"
          ></div>
        </div>

        <!--颜色渐变进度-->
        <div class="lightness_control_bar">
          <canvas
            id="progress_color"
            :width="progress_width"
            height="14"
          ></canvas>
          <el-slider
           tooltip-class="progress_color_slider_new"
            v-model="progress_color_slider"
            class="progress_color_slider"
          ></el-slider>
        </div>
      </div>

      <!--色盘模式-->
      <div
        class="custom_color_panel"
        v-show="type === 'custom_color_panel'"
      >
        <div class="f_color_picker_header">
          <div
            class="back"
            @click="back"
          ></div>
        </div>
        <div class="palette palette_frame">
          <canvas
            id="palette_color"
            :width="progress_width"
            height="125"
          ></canvas>
          <div class="color_draggable"></div>
          <div class="draggable_layer"></div>
        </div>

        <!--全色渐变进度-->
        <div class="lightness_control_bar">
          <canvas
            id="all_color"
            :width="progress_width"
            height="14"
          ></canvas>
          <el-slider
            tooltip-class="progress_color_slider_new"
            v-model="all_color_slider"
            class="progress_color_slider"
          ></el-slider>
        </div>
      </div>

      <!--颜色渐变进度-->
      <div class="lightness_control_bar lightness_opacity_bar">
        <canvas
          id="progress_opacity"
          :width="progress_width"
          height="14"
        ></canvas>
        <el-slider
          tooltip-class="progress_color_slider_new"
          v-model="opacity"
          class="progress_color_slider"
          @change="opacity_change"
        ></el-slider>
      </div>

      <div class="current_row">
        <div class="current_color">
          <p :style="{
            backgroundColor:color_view
          }"></p>
        </div>
        <div style="display: flex; align-items: center;">
          <span class="title">#</span>
          <input
            type="text"
            class="current_text"
            v-model="input_color"
            @change="inputChange"
            :maxlength="6"
          />
          <span class="input_placeholder">{{$t('components_my_color_picker_index_2299')}}</span>
        </div>
      </div>

      <!-- 最近使用 -->
      <div class="recent_use">
        <div class="recent_use_text">{{$t('components_my_color_picker_index_2300')}}</div>
        <div class="color_table">
          <div
            class="color_cube"
            v-for="(item,i) in recent_use"
            :key="i"
            :style="{
            backgroundColor:item.btn_color
          }"
            :class="item.type === 'transparent' ? 'transparent_btn' : ''"
            @click="progress_color_change(i,item)"
          ></div>
        </div>
      </div>
      <div class="recent_use">
        <div class="recent_use_text">{{$t('components_my_color_picker_index_2301')}}</div>
        <div class="color_table">
          <div
            class="color_cube"
            v-for="(item,i) in primaryColors"
            :key="i"
            :style="{
            backgroundColor:item.btn_color
          }"
            :class="item.type === 'transparent' ? 'transparent_btn' : ''"
            @click="progress_color_change(i,item)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

window._this = {}
import ColorSchemeDesigner from './../../base/colorschemedesigner'

let colorSchemeDesigner

import colors from "./color_config";

export default {
  name: "picker",
  data() {
    return {
      //pure_color 纯色   linear_gradient 渐变
      Pattern: this.$store.state.color.Pattern,
      colors: [],
      progress_width: 230,
      select_color: this.$store.state.color.select_color, //纯色的值
      opacity: 100,
      input_color: "",
      input_color_temp: '',
      progress_color_slider: 50,
      progress_opacity_slider: 100,
      type: "default_panel", //default_panel 颜色按钮   custom_color_panel 色盘模式
      all_color_slider: 0,
      linear_gradient_width: 125,
      select_pointer: "start",
      linear_gradient: this.$store.state.color.linear_gradient
        ? JSON.parse(JSON.stringify(this.$store.state.color.linear_gradient))
        : {},
      now_select_type: "", //解决每次选中透明后，再选别的依然是透明的问题
      recent_use: [],
      primaryColors: []
    };
  },
  props: {},
  watch: {
    progress_color_slider(val) {
      this.slider_change(
        "progress_color",
        parseInt(this.progress_width * (val / 100))
      );
    },
    all_color_slider(val) {
      this.slider_change(
        "all_color",
        parseInt(this.progress_width * (val / 100))
      );

      //色盘重新渲染
      this.palette_color_init();
    },
    select_color(val) {
      this.$store.state.color.color_change({
        select_color: val
      });
    },
    linear_gradient: {
      handler(val, oldVar) {
        this.$store.state.color.color_change({
          linear_gradient: this.linear_gradient
        });
      },
      deep: true
    },
    Pattern(val) {
      this.$store.state.color.color_change({
        Pattern: val
      });
      this.progress_color_init(this.progress_colors(this.color_view));
      //透明条展示
      this.progress_opacity_init(this.color_view);

      //透明度进度初始化
      this.opacity_init();
      if (val === "linear_gradient") {
        this.$nextTick(() => {
          //渐变条左右拖拽
          this.gradient_draggable_init();
        });
      }
    },
    select_pointer(val) {
      //进度条颜色展示
      this.progress_color_init(this.progress_colors(this.color_view));

      //透明条展示
      this.progress_opacity_init(this.color_view);

      //透明度进度初始化
      this.opacity_init();
    },
    color_view(val) {
      this.input_color = this.rgbToHex(val);
    },
    input_color(val) {
      this.recommendColor(val)
    }
  },
  methods: {
    //透明度改变
    opacity_change() {
      if (this.Pattern === "linear_gradient") {
        this.linear_gradient[this.select_pointer + "_color"] = this.rgbToRgba(
          this.linear_gradient[this.select_pointer + "_color"]
        );
      } else {
        this.select_color = this.rgbToRgba(this.select_color);
      }
    },
    //纯色或渐变模式下的赋值
    set_color_judge(color) {
      //如果是渐变模式
      if (this.Pattern === "linear_gradient") {
        this.linear_gradient[this.select_pointer + "_color"] = this.rgbToRgba(
          color
        );
      } else {
        this.select_color = this.rgbToRgba(color);
      }
    },
    progress_color_change(i, item) {
      //如果选中的是透明
      if (item.type === "transparent") {
        this.opacity = 0;
        this.now_select_type = "transparent";
      } else {
        //本次选择不是选择透明，且上一次是选中透明
        this.reset_opacity();
      }

      this.set_color_judge(item.btn_color);
      if(item.progress_color){
        this.progress_color_init(item.progress_color);
      }
      this.progress_opacity_init(item.btn_color);
      this.input_color = this.rgbToHex(item.btn_color);
      this.save_to_localStorage(item);
    },

    recent_use_init() {
      const arr = localStorage.getItem("colors");
      if (arr) {
        try {
          this.recent_use = JSON.parse(arr);
          this.colors_init(this.recent_use);
        } catch (r) {
        }
      }
    },

    //将颜色存入本地
    save_to_localStorage(item) {
      const arr = localStorage.getItem("colors");

      let colors = [];
      if (arr) {
        try {
          colors = JSON.parse(arr);
          if (colors.length > 4) {
            colors.pop();
          }
          colors.unshift(this.add_localStorage(item));
        } catch (r) {
          colors.push(this.add_localStorage(item));
        }
      } else {
        //如不存在，则设置一个
        colors.push(this.add_localStorage(item));
      }
      const str = JSON.stringify(colors);
      localStorage.setItem("colors", str);
      this.recent_use_init();
    },

    add_localStorage(item) {
      const color = {
        btn_color: item.btn_color,
        progress_color: []
      };
      if (item.type === "transparent") {
        color.type = "transparent";
      }
      return color;
    },

    //本次选择不是选择透明，且上一次是选中透明
    reset_opacity() {
      if (this.now_select_type == "transparent") {
        this.opacity = 100;
        this.now_select_type = "";
      }
    },

    //进度条颜色展示
    progress_color_init(color) {
      const can = document.getElementById("progress_color");
      const ctx = can.getContext("2d");
      const gradientBar = ctx.createLinearGradient(
        0,
        0,
        this.progress_width,
        0
      );
      gradientBar.addColorStop(0, color[0]);
      gradientBar.addColorStop(1 / 5, color[1]);
      gradientBar.addColorStop(2 / 5, color[2]);
      gradientBar.addColorStop(3 / 5, color[3]);
      gradientBar.addColorStop(4 / 5, color[4]);
      gradientBar.addColorStop(1, color[5]);
      ctx.clearRect(0, 0, this.progress_width, 14);
      ctx.fillStyle = gradientBar;
      ctx.fillRect(0, 0, this.progress_width, 14);
      this.progress_color_slider = 50; //进入条在中间，就是当前选择的颜色
    },

    //透明条展示
    progress_opacity_init(color) {
      const {r, g, b, a} = this.rgbaToRgb(color);
      const can = document.getElementById("progress_opacity");
      const ctx = can.getContext("2d");
      const gradientBar = ctx.createLinearGradient(
        0,
        0,
        this.progress_width,
        0
      );
      gradientBar.addColorStop(0, `rgba(${r},${g},${b},0)`);
      gradientBar.addColorStop(1, `rgba(${r},${g},${b},1)`);
      ctx.clearRect(0, 0, this.progress_width, 14);
      ctx.fillStyle = gradientBar;
      ctx.fillRect(0, 0, this.progress_width, 14);
    },

    //rgba转中颜色进度条
    progress_colors(color) {
      let startColor = [];
      if (typeof color == "string") {
        startColor = color
          .replace("rgb(", "")
          .replace("rgba(", "")
          .replace(")", "")
          .split(",");
      }
      if (color instanceof Array) {
        startColor = color;
      }
      for (let i = 0; i < startColor.length; i++) {
        startColor[i] = parseInt(startColor[i]);
      }

      let progress = [];
      const white = [255, 255, 255];
      const black = [0, 0, 0];
      const w_rStep = (white[0] - startColor[0]) / 3;
      const w_gStep = (white[1] - startColor[1]) / 3;
      const w_bStep = (white[2] - startColor[2]) / 3;

      const b_rStep = (startColor[0] - black[0]) / 3;
      const b_gStep = (startColor[1] - black[1]) / 3;
      const b_bStep = (startColor[2] - black[2]) / 3;

      //向左渐变
      for (let i = 0; i < 4; i++) {
        const {r, g, b} = this.rgb_judge(
          parseInt(w_rStep * i + startColor[0]),
          parseInt(w_gStep * i + startColor[1]),
          parseInt(w_bStep * i + startColor[2])
        );
        progress.unshift(`rgb(${r},${g},${b})`);
      }

      for (let i = 1; i < 4; i++) {
        const {r, g, b} = this.rgb_judge(
          parseInt(startColor[0] - b_rStep * i),
          parseInt(startColor[1] - b_gStep * i),
          parseInt(startColor[2] - b_bStep * i)
        );
        progress.push(`rgb(${r},${g},${b})`);
      }

      return progress;
    },

    rgb_judge(r, g, b) {
      if (r > 255 || g > 255 || b > 255) {
        r = 255;
        g = 255;
        b = 255;
      }
      if (r < 0 || g < 0 || b < 0) {
        r = 0;
        g = 0;
        b = 0;
      }
      return {r, g, b};
    },

    //配置颜色初始化
    colors_init(arr) {
      const colors = arr.map(item => {
        item.progress_color = this.progress_colors(item.btn_color);
        return item;
      });
      return colors

    },
    hexToRgb(hex) {
      var reg = /^[0-9a-zA-Z]$/;
      let r = "";
      if (!reg.test(hex) && hex.length == 6) {
        r =
          "rgb(" +
          parseInt("0x" + hex.slice(0, 2)) +
          "," +
          parseInt("0x" + hex.slice(2, 4)) +
          "," +
          parseInt("0x" + hex.slice(4, 6)) +
          ")";
      }
      return r;
    },
    rgbToRgba(color) {
      const {r, g, b} = this.rgbaToRgb(color);
      return `rgba(${r},${g},${b},${this.opacity / 100})`;
    },
    rgbToHex(color) {
      const {r, g, b} = this.rgbaToRgb(color);
      var hex = ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      return hex;
    },
    //传入rgba格式
    rgbaToRgb(color) {
      var rgb = color.split(",");
      var r = parseInt(rgb[0].split("(")[1]);
      var g = parseInt(rgb[1]);
      var b = parseInt(rgb[2].split(")")[0]);
      var a = 1;
      if (rgb.length >= 4) {
        a = parseFloat(rgb[3].replace(")", ""));
      }
      return {r, g, b, a};
    },

    //输入色值
    inputChange(e) {
      const r = this.hexToRgb(e.target.value);

      if (r != "") {
        const rgba_color = this.rgbToRgba(r);
        this.set_color_judge(rgba_color);
        const progress_colors = this.progress_colors(r);
        this.progress_color_init(progress_colors);
        this.progress_opacity_init(r);
        this.progress_color_slider = 50; //进入条在中间，就是当前选择的颜色
        this.palette_color_init();
      }
    },

    palette_color_init() {
      const can = document.getElementById("palette_color");
      const ctx = can.getContext("2d");

      ctx.clearRect(0, 0, this.progress_width, 125);
      // 底色填充
      const gradientBase = ctx.createLinearGradient(
        0,
        0,
        this.progress_width,
        0
      );
      gradientBase.addColorStop(0, "rgba(255,255,255,1)");
      gradientBase.addColorStop(1, this.color_view);
      ctx.fillStyle = gradientBase;
      ctx.fillRect(0, 0, this.progress_width, this.progress_width);

      // 第二次填充，黑色到透明
      var my_gradient1 = ctx.createLinearGradient(0, 0, 0, 125);
      my_gradient1.addColorStop(0, "rgba(0,0,0,0)");
      my_gradient1.addColorStop(1, "rgba(0,0,0,1)");
      ctx.fillStyle = my_gradient1;
      ctx.fillRect(0, 0, this.progress_width, 125);
    },

    back() {
      this.type = "default_panel";
    },
    to_custom_color() {
      //本次选择不是选择透明，且上一次是选中透明
      this.reset_opacity();
      this.type = "custom_color_panel";
      this.$nextTick(() => {
        this.palette_color_init();
        this.all_color_init();
        $(".color_draggable").css("display", "none");
        this.color_draggable_init();
      });
    },
    //全条颜色展示
    all_color_init() {
      const can = document.getElementById("all_color");
      const ctx = can.getContext("2d");
      const gradientBar = ctx.createLinearGradient(
        0,
        0,
        this.progress_width,
        0
      );
      gradientBar.addColorStop(0, "rgb(255, 0, 0)");
      gradientBar.addColorStop(1 / 6, "rgb(255, 255, 0)");
      gradientBar.addColorStop(2 / 6, "rgb(0, 255, 0)");
      gradientBar.addColorStop(3 / 6, "rgb(0, 255, 255)");
      gradientBar.addColorStop(4 / 6, "rgb(0, 0, 255)");
      gradientBar.addColorStop(5 / 6, "rgb(255, 0, 255)");
      gradientBar.addColorStop(1, "rgb(255, 0, 0)");
      ctx.clearRect(0, 0, this.progress_width, 14);
      ctx.fillStyle = gradientBar;
      ctx.fillRect(0, 0, this.progress_width, 14);
    },

    slider_change(el, x, y = 1) {
      //const x = parseInt(this.progress_width * (val/100));
      const can = document.getElementById(el);
      const ctx = can.getContext("2d");
      const color = ctx.getImageData(x, y, 1, 1).data;

      const rgba_color = this.rgbToRgba(
        `rgb(${color[0]},${color[1]},${color[2]})`
      );
      this.set_color_judge(rgba_color);
      this.input_color = this.rgbToHex(this.select_color);
      this.progress_opacity_init(this.color_view);
    },

    //色板小圆点拖拽
    color_draggable_init() {
      const that = this;
      $(".draggable_layer").mousedown(function (e) {
        const x = e.offsetX;
        const y = e.offsetY;
        $(".color_draggable").css({
          top: y - 5 + "px",
          left: x - 5 + "px",
          display: "block"
        });
        that.slider_change("palette_color", x, y);
        $(this).mousemove(function (e) {
          const m_x = e.offsetX;
          const m_y = e.offsetY;
          that.slider_change("palette_color", m_x, m_y);
          $(".color_draggable").css({
            top: m_y - 5 + "px",
            left: m_x - 5 + "px"
          });
        });
      });

      $(window).mouseup(function () {
        $(".draggable_layer").unbind("mousemove");
      });
    },

    //渐变条左右拖拽
    gradient_draggable_init() {
      const that = this;
      let x = 0;
      let sport_dom = "";
      let s_x = 0;
      $(".gradient_start_pointer").mousedown(function (e) {
        x = parseFloat($(this).css("left"));
        s_x = e.clientX;
        sport_dom = "start";
        that.select_pointer = "start";
      });

      $(".gradient_end_pointer").mousedown(function (e) {
        x = parseFloat($(this).css("left"));
        s_x = e.clientX;
        sport_dom = "end";
        that.select_pointer = "end";
      });

      $(".my_picker").mousemove(function (e) {
        if (sport_dom != "") {
          let m_x = e.clientX - s_x + x;
          if (sport_dom == "start") {
            const s_p_x = parseFloat($(".gradient_end_pointer").css("left"));
            if (m_x < 0) {
              m_x = 0;
            }
            if (m_x + 15 >= s_p_x) {
              return;
            }
          } else if (sport_dom == "end") {
            const s_p_x = parseFloat($(".gradient_start_pointer").css("left"));
            if (m_x > that.linear_gradient_width) {
              m_x = that.linear_gradient_width;
            }
            if (m_x - 15 <= s_p_x) {
              return;
            }
          }

          $(".gradient_" + sport_dom + "_pointer").css("left", m_x + "px");
          that.linear_gradient[sport_dom + "_pointer"] =
            (m_x / that.linear_gradient_width) * 100;
        }
      });

      $(window).mouseup(function () {
        sport_dom = "";
      });
    },

    deg_change(e) {
      this.linear_gradient.deg = parseFloat(e.target.value);
    },

    picker_close() {
      this.isShow = false;
    },

    opacity_init() {
      if (this.Pattern === "linear_gradient") {
        const {a} = this.rgbaToRgb(
          this.linear_gradient[this.select_pointer + "_color"]
        );
        this.opacity = a * 100;
      } else {
        const {a} = this.rgbaToRgb(this.select_color);
        this.opacity = a * 100;
      }
    },
    recommendColor(color) {
      if (colorSchemeDesigner) {
        let palette = colorSchemeDesigner.getPalette()
        palette && palette.Primary && palette.setHex(color)
      }
    }
  },
  computed: {
    color_view() {
      if (this.Pattern == "linear_gradient") {
        return this.linear_gradient[this.select_pointer + "_color"];
      } else {
        return this.select_color;
      }
    }
  },
  mounted() {
    this.opacity_init();
    //配置颜色初始化
    this.colors = this.colors_init(colors);

    //进度条颜色展示
    this.progress_color_init(this.progress_colors(this.color_view));

    //透明条展示
    this.progress_opacity_init(this.color_view);

    //渐变条左右拖拽
    this.gradient_draggable_init();

    //输入框初始化
    this.input_color = this.rgbToHex(this.color_view);

    //最近使用初始化
    this.recent_use_init();

    let self = this
    colorSchemeDesigner = ColorSchemeDesigner({
      defaultColor: this.input_color,
      onColorChange(colors) {
        colors.shift()
        colors.forEach(color => {
          color.btn_color = color.RGB.getCSS()
        })
        self.primaryColors = colors
      }
    })
  }
};
</script>

<style scoped lang="scss">
.my_picker {
  top: 100px;
  left: 300px;
  position: fixed;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: white;
  z-index: 4008;

  .panel_wrap {
    padding: 12px;

    .color_table {
      margin-bottom: 15px;
      width: 225px;
      height: 150px;
      box-shadow: 3px 0 5px rgba(0, 0, 0, 0.08);

      .color_cube {
        float: left;
        position: relative;
        width: 25px;
        height: 25px;
        cursor: pointer;
        overflow: hidden;
        transition: all 0.2s;
      }

      .color_cube:hover {
        transform: scale(1.2);
        z-index: 99;
      }

      .transparent::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: white;
      }

      .transparent::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 0;
        transform: rotate(-45deg);
        transform-origin: 0 0;
        width: 35px;
        height: 1px;
        background: red;
      }
    }

    .lightness_control_bar {
      position: relative;
      margin-bottom: 15px;
      width: 232px;
      height: 16px;
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);
      border-radius: 15px;
      border: 1px #e3e3e3 solid;

      canvas {
        border-radius: 15px;
      }
    }
  }

  .progress_color_slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .custom_color_panel {
    position: relative;
    box-sizing: border-box;
    width: 230px;

    .f_color_picker_header {
      margin-bottom: 12px;
      z-index: 999;

      .back {
        position: relative;
        width: 8px;
        height: 14px;
        background: 0;
        cursor: pointer;
      }

      .back:before {
        content: "";
        position: absolute;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-right: 8px solid #333;
      }

      .back:after {
        content: "";
        position: absolute;
        left: 1px;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-right: 8px solid #fff;
      }
    }

    .palette {
      position: relative;
      margin-bottom: 15px;
      width: 100%;
      height: 125px;
    }
  }

  .colour {
    background-image: url("./image/cai.png");
    background-repeat: no-repeat;
  }
}

.lightness_opacity_bar {
  background-image: url("./image/clear1.png");
}

.current_row {
  margin-bottom: 20px;

  .current_color {
    float: left;
    margin-right: 10px;
    width: 50px;
    height: 24px;
    box-shadow: 3px 0 5px rgba(0, 0, 0, 0.08);
    background-image: url("./image/clear1.png");

    p {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    float: left;
    line-height: 24px;
    margin-right: 10px;
  }

  .current_text {
    width: 64px;
    text-align: center;
    outline: 0;
    border-top: 0;
    border-right: 0;
    border-left: none;
    border-bottom: 1px solid #e3e2e8;
    position: relative;
    padding: 0 4px;
    font-size: 14px;
  }
}

.color_draggable {
  display: none;
  position: absolute;
  width: 10px;
  height: 10px;
  border: 2px solid #409eff;
  border-radius: 50%;
  box-sizing: border-box;
  top: 0;
  left: 0px;
  z-index: 99;
  /*transform: translate(-5px,-5px);*/
}

.draggable_layer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 100;
}

.gradient_control {
  height: 30px;
  position: relative;
  margin-bottom: 12px;
  width: 100%;

  .gradient_control_bar_wrap {
    float: left;
    position: relative;
    width: 125px;
    height: 30px;
    border-radius: 8px;

    .gradient_control_bar {
      width: 125px;
      height: 16px;
      float: left;
      border-radius: 8px;
    }

    .gradient_control_slider {
      position: relative;
      float: left;
      width: 125px;
      height: 17px;
      top: -5px;

      .gradient_control_bar_pointer {
        z-index: 100;
        position: absolute;
        width: 12px;
        height: 17px;
        top: 0;
        cursor: pointer;
        background-image: url("./image/d_p.png");
        background-repeat: no-repeat;

        .pointer_color {
          width: 7px;
          height: 7px;
          margin-top: 8px;
          margin-left: 2px;
        }
      }

      .sele_pointer {
        background-image: url("./image/s_p.png");
      }

      .start_pointer {
        transform: translate(-6px, 0);
      }

      .end_pointer {
        transform: translate(-6px, 0);
      }
    }

    .gradient_drag_move {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99;
    }
  }

  .gradient_control_direction {
    float: left;
    position: relative;
    margin-left: 15px;
    width: 16px;
    height: 16px;
    border: 1px solid #666;
    border-radius: 50%;
    cursor: pointer;
  }

  .gradient_control_direction::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 50%;
    height: 1px;
    background-color: #666;
  }

  .gradient_control_angle {
    float: left;
    margin: 0 1px;

    .gradient_control_direction_text {
      width: 25px;
      border-bottom: 1px solid #e3e2e8;
      font-size: 12px;
      color: #666;
      overflow: hidden;
      text-align: center;
      outline: 0;
      border-top: 0;
      border-right: 0;
      border-left: none;
    }
  }

  .gradient_control_preview {
    float: left;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    margin-left: 10px;

    .color_cube {
      width: 100%;
      height: 100%;
    }
  }
}

.f_color_picker_header {
  margin-bottom: 12px;

  .small_text {
    position: relative;
    padding: 0 4px;
    font-size: 14px;
  }
}

.input_placeholder {
  font-size: 12px;
  color: #ccc;
}

.recent_use {
  .recent_use_text {
    width: 48px;
    margin-right: 10px;
    font-size: 12px;
    color: #666;
    float: left;
    height: 25px;
    line-height: 25px;
  }

  .color_table {
    width: 140px !important;
    box-shadow: none !important;
    float: left;
    height: 25px !important;


    .color_cube {
      margin-left: 2px;
      border: 1px solid #ddd;
    }
  }

  .transparent_btn {
    background-color: transparent !important;
    background-image: url("./image/clear1.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_color_picker/index.vue